/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetIntegrationEnabledRequest
 */
export interface SetIntegrationEnabledRequest {
    /**
     * 
     */
    provider: SetIntegrationEnabledRequestProviderEnum;
    /**
     * 
     */
    enabled: boolean;
}


/**
 * @export
 */
export const SetIntegrationEnabledRequestProviderEnum = {
    Tehtris: 'tehtris',
    NinjaOne: 'ninjaOne',
    Autotask: 'autotask',
} as const;
export type SetIntegrationEnabledRequestProviderEnum = typeof SetIntegrationEnabledRequestProviderEnum[keyof typeof SetIntegrationEnabledRequestProviderEnum];


/**
 * Check if a given object implements the SetIntegrationEnabledRequest interface.
 */
export function instanceOfSetIntegrationEnabledRequest(value: object): value is SetIntegrationEnabledRequest {
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function SetIntegrationEnabledRequestFromJSON(json: any): SetIntegrationEnabledRequest {
    return SetIntegrationEnabledRequestFromJSONTyped(json, false);
}

export function SetIntegrationEnabledRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetIntegrationEnabledRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'enabled': json['enabled'],
    };
}

export function SetIntegrationEnabledRequestToJSON(json: any): SetIntegrationEnabledRequest {
    return SetIntegrationEnabledRequestToJSONTyped(json, false);
}

export function SetIntegrationEnabledRequestToJSONTyped(value?: SetIntegrationEnabledRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provider': value['provider'],
        'enabled': value['enabled'],
    };
}

